import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone, faMapMarkerAlt, faLink } from '@fortawesome/free-solid-svg-icons';
import initialStyles from '../settings/initialStyles';
import { linkIcons, linkText } from '../settings/linkData';
import ThemeConfigPanel from '../settings/ThemeConfigPanel';
import Notification from '../components/notification/Notification';
import '../styles/TemplateEleven.css'; // Assuming you will create TemplateEleven.css for styles

const themePresets = {
    default: initialStyles,
    dark: {
        backgroundColor: '#333',
        secondaryBackgroundColor: '#555',
        headerBackgroundColor: '#222',
        headerTextColor: '#fff',
        subheaderTextColor: '#555',
        textColor: '#eee',
        headerFontSize: '1.6',
        subheaderFontSize: '1.5',
        bodyFontSize: '1'
    },
    light: {
        backgroundColor: '#f9f9f9',
        secondaryBackgroundColor: '#e0e0e0',
        headerBackgroundColor: '#ddd',
        headerTextColor: '#333',
        subheaderTextColor: '#555',
        textColor: '#111',
        headerFontSize: '1.6',
        subheaderFontSize: '1.5',
        bodyFontSize: '1'
    }
};

const ViewTemplateEleven = ({ template, isDownloading }) => {
    const [styles, setStyles] = useState(initialStyles);
    const [notification, setNotification] = useState(null);

    const handleStyleChange = (e) => {
        const { name, value } = e.target;
        setStyles((prevStyles) => ({
            ...prevStyles,
            [name]: value,
        }));
    };

    const applyPreset = (preset) => {
        setStyles(themePresets[preset]);
    };

    const saveCustomTheme = () => {
        localStorage.setItem('customTheme', JSON.stringify(styles));
        setNotification({ message: 'Custom theme saved!', isError: false });
    };

    const loadCustomTheme = () => {
        const customTheme = localStorage.getItem('customTheme');
        if (customTheme) {
            setStyles(JSON.parse(customTheme));
            setNotification({ message: 'Custom theme loaded!', isError: false });
        } else {
            setNotification({ message: 'No custom theme found!', isError: true });
        }
    };

    const templateData = template || {};

    const baseUrl = process.env.REACT_APP_API_BASE_URL || 'https://venusresume.vercel.app/';
    const imageUrl = templateData?.image?.startsWith('/')
        ? `${baseUrl}${templateData.image}`
        : templateData.image;

    return (
        <div className='holder'>
            <div className="template-eleven-container" style={{ backgroundColor: styles.backgroundColor }}>
                {notification && (
                    <Notification
                        message={notification.message}
                        isError={notification.isError}
                        onClose={() => setNotification(null)}
                    />
                )}
                <div className="template-eleven">
                    <div className="template-eleven-left">

                        <div className="template-eleven-name" style={{ fontSize: `${styles.headerFontSize}em`, color: styles.headerTextColor }} >
                            {templateData?.personName && <h1 className="template-eleven-name" style={{ fontSize: `${styles.headerFontSize}em`, color: styles.headerTextColor }}>{templateData?.personName}</h1>}
                        </div>

                        <div className="template-eleven-aboutMe">
                            <div className="template-eleven-section">
                                <h3 style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}>About Me</h3>
                                {templateData?.aboutMe && <p className="template-eleven-aboutMe" style={{ fontSize: `${styles.bodyFontSize}em`, color: styles.textColor }}>{templateData?.aboutMe}</p>}
                            </div>
                        </div>

                        <div className="template-eleven-skills">
                            <div className="template-eleven-section">
                                <h3 style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}>Skills</h3>
                                <ul>
                                    {templateData?.skills && template.skills.map((skill, index) => (
                                        <li key={index} style={{ fontSize: `${styles.bodyFontSize}em` }}>{skill}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="template-eleven-software-skills">
                            <div className="template-eleven-section">
                                <h3 style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}>Software Skills</h3>
                                <ul>
                                    {templateData?.softwareSkills && template.softwareSkills.map((software, index) => (
                                        <li key={index} style={{ fontSize: `${styles.bodyFontSize}em` }}>{software}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="template-eleven-languages">
                            <div className="template-eleven-section">
                                <h3 style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}>Languages</h3>
                                <ul>
                                    {templateData?.languages && template.languages.map((language, index) => (
                                        <li key={index} style={{ fontSize: `${styles.bodyFontSize}em` }}>{language}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                    </div>
                    <div className="template-eleven-right" style={{ backgroundColor: styles.secondaryBackgroundColor, }}>
                        <div className="template-eleven-profile" style={{ backgroundColor: styles.headerBackgroundColor, paddingTop: "10px" }}>
                            {imageUrl && <img src={imageUrl} alt={template.personName} className="template-eleven-image" />}
                        </div>
                        <div className="template-eleven-contact">
                            {templateData?.contact && (
                                <div className="template-eleven-section">
                                    <h3 style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}>Contact</h3>
                                    {template.contact.phone && <p><FontAwesomeIcon icon={faPhone} style={{ fontSize: `${styles.bodyFontSize}em` }} /> {template.contact.phone}</p>}
                                    {template.contact.email && <p><FontAwesomeIcon icon={faEnvelope} style={{ fontSize: `${styles.bodyFontSize}em` }} /> {template.contact.email}</p>}
                                    {template.contact.address && <p><FontAwesomeIcon icon={faMapMarkerAlt} style={{ fontSize: `${styles.bodyFontSize}em` }} /> {template.contact.address}</p>}
                                </div>
                            )}
                        </div>
                        <div className="template-eleven-education">
                            <div className="template-eleven-section">
                                <h3 style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}>Education</h3>
                                {templateData?.education && template.education.map((edu, index) => (
                                    <div key={index} className="template-eleven-education-item">
                                        <p className="template-eleven-degree" style={{ fontSize: `${styles.bodyFontSize}em` }}>{edu.degree}</p>
                                        <p className="template-eleven-institution" style={{ fontSize: `${styles.bodyFontSize}em` }}>{edu.institution}</p>
                                        <p style={{ fontSize: `${styles.bodyFontSize}em`, fontWeight: "200" }}>
                                            (
                                            {edu.startDate && new Date(edu.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                            {edu.endDate !== "Present" ? new Date(edu.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                            )
                                        </p>
                                        <p className="template-eleven-institution" style={{ fontSize: `${styles.bodyFontSize}em` }}>{edu.description}</p>

                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="template-eleven-work-experience">
                            <div className="template-eleven-section">
                                <h3 style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}>Work Experience</h3>
                                {templateData?.workExperience && template.workExperience.map((experience, index) => (
                                    <div key={index} className="template-eleven-experience-item">
                                        <p className="template-eleven-role" style={{ fontSize: `${styles.bodyFontSize}em` }}>{experience.role}</p>
                                        <p className="template-eleven-company-location" style={{ fontSize: `${styles.bodyFontSize}em` }}>{experience.company} / {experience.location}</p>
                                        <p className="template-eleven-date" style={{ fontSize: `${styles.bodyFontSize}em` }}>
                                            {experience.location && (
                                                <p className="location">
                                                    (
                                                    {experience.startDate && new Date(experience.startDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })} -
                                                    {experience.endDate !== "Present" ? new Date(experience.endDate).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : 'Present'}
                                                    )
                                                </p>
                                            )}
                                        </p>
                                        <p className="template-eleven-description" style={{ fontSize: `${styles.bodyFontSize}em` }}>{experience.description}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="template-eleven-certificates">
                            {templateData?.certificates && (
                                <div className="template-eleven-section">
                                    <h3 style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}>Certificates</h3>
                                    {template.certificates.map((certificate, index) => (
                                        <div key={index} className="template-eleven-certificate-item">
                                            <p className="template-eleven-title" style={{ fontSize: `${styles.bodyFontSize}em` }}>Title: {certificate.title}</p>
                                            <p className="template-eleven-institution" style={{ fontSize: `${styles.bodyFontSize}em` }}>Institution: {certificate.institution}</p>
                                            <p className="template-eleven-date" style={{ fontSize: `${styles.bodyFontSize}em` }}>
                                                Date Received: {new Date(certificate.DateReceived).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <div className="template-eleven-hobbies">
                            {templateData?.hobbies && template.hobbies.length > 0 && (
                                <div className="template-eleven-section">
                                    <h3 style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}>Hobbies</h3>
                                    <ul>
                                        {template.hobbies.map((hobby, index) => (
                                            <li key={index} style={{ fontSize: `${styles.bodyFontSize}em` }}>{hobby}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                        <div className="template-eleven-links">
                            {templateData?.links && (
                                <div className="template-eleven-section">
                                    <h3 style={{ fontSize: `${styles.subheaderFontSize}em`, color: styles.subheaderTextColor }}>Links</h3>
                                    {Object.entries(templateData.links).map(([key, value]) => (
                                        <p key={key}>
                                            <FontAwesomeIcon icon={linkIcons[key] || faLink} />
                                            <a href={value} target="_blank" rel="noopener noreferrer">
                                                <span style={{ fontSize: `${styles.bodyFontSize}em` }}>{linkText[key]}</span>
                                            </a>
                                        </p>
                                    ))}
                                </div>
                            )}

                        </div>

                    </div>
                </div>
            </div>
            {!isDownloading && (
                <ThemeConfigPanel
                    styles={styles}
                    handleStyleChange={handleStyleChange}
                    applyPreset={applyPreset}
                    saveCustomTheme={saveCustomTheme}
                    loadCustomTheme={loadCustomTheme}
                />
            )}
        </div>
    );
};

export default ViewTemplateEleven;
